import React from "react"
import styles from "./ProgressBar.module.css"
import t from "frontend/utils/translations"

const ProgressBar = ({ percent }) => {
  const progress = Math.min(Math.max(percent, 0), 100)

  const getProgressClass = () => {
    if (progress < 25) {
      return styles.under25
    } else if (progress < 50) {
      return styles.under50
    } else {
      return ""
    }
  }
  return (
    <div
      className={styles.container}
      aria-label={`${t("upload.form.discoverability_score.current", { score: percent })} ${t(
        "upload.form.discoverability_score.description"
      )}`}
      tabIndex="0"
    >
      <span
        className={`${styles.progress} ${getProgressClass()}`}
        style={{ width: `${progress}%` }}
        data-testid="progress"
      />
    </div>
  )
}

ProgressBar.defaultProps = {
  percent: 0,
}

export default ProgressBar
